import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog'
import T from 'i18n-react'

import { ROLE_OPTIONS } from 'containers/Admin/User/UserSelection/constants'
import UserInput from 'components/custom/UserSelection/index'
import Dropdown from './Dropdown'
import FormTitle from 'components/fulcrum/formTitle/FormTitle'

import {
  fetchEmployeeListWithImages as fetchEmployeeList,
} from 'containers/User/actions'
import {
  employeeListWithImageValues as employeeListSelector,
  isLoadingEmployeeList,
} from 'containers/User/selectors'
import {
  setInactiveDialog,
} from 'containers/Admin/User/User/actions'
import {
  changeSelectedRole,
  changeSelectedUser,
  postUser,
} from './actions'
import {
  activeDialogSelector
} from 'containers/Admin/User/User/selectors'
import {
  userSelector,
  roleStateSelector,
} from './selectors'

import userRolesSagas from './sagas'

const mapStateToProps = (state) => {
  return {
    role: roleStateSelector(state),
    employee: userSelector(state),
    employeeList: employeeListSelector(state),
    isLoading: isLoadingEmployeeList(state),
    active: activeDialogSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  const addRoleToUsers = role => R.map(user => ({ role, ...user }))

  return {
    fetchEmployeeList: (query) => dispatch(fetchEmployeeList(query)),
    toggleInactiveDialog: () => dispatch(setInactiveDialog()),
    onSelectEmployee: (user) => dispatch(changeSelectedUser(user)),
    onSelectRole: (role) => dispatch(changeSelectedRole(role)),
    onSave: () => dispatch(postUser()),
  }
}

class UserRole extends Component {
  onCancel = () => this.props.toggleInactiveDialog()
  onSave = () => {
    this.props.onSave()
    this.props.toggleInactiveDialog()
  }

  actions = [
    { label: 'Save', onClick: this.onSave },
    { label: 'Cancel', onClick: this.onCancel },
  ]

  roles = R.compose(
    R.map(value => ({ value, label: value })),
    R.values
  )(ROLE_OPTIONS)

  render() {
    const {
      role,
      employee,
      employeeList,
      fetchEmployeeList,
      onSelectEmployee,
      onSelectRole,
      isLoading,
      active,
      toggleInactiveDialog,
    } = this.props

    return (
      <Dialog
        actions={this.actions}
        active={active}
        title={T.translate('containers.admin.userRole.index.title')}
        onOverlayClick={toggleInactiveDialog}
        onEscKeyDown={toggleInactiveDialog}
      >
        <FormTitle title='User'>
          <UserInput
            clearable={false}
            options={employeeList}
            onInputChange={fetchEmployeeList}
            onChange={onSelectEmployee}
            value={employee}
            isLoading={isLoading}
          />
        </FormTitle>
        <FormTitle title='Role'>
          <Dropdown
            value={role}
            onChange={onSelectRole}
            source={this.roles}
          />
        </FormTitle>
      </Dialog>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ userRolesSagas })

export default compose(
  withSagas,
  withConnect,
)(UserRole)
